import React from 'react';
import '../../App.css';
import Hero from '../HeroEmpresaDe'
import Empresa from '../Empresa/EmpresaDe'
import Missao from '../Empresa/MissaoDe'
import MachRang from '../Empresa/MachRang'
import PolitGest from '../Empresa/PolitGestDe'
import SalesDist from '../Empresa/SalesDist'
import Footer from '../../Footer/FooterDe';

function Noticias(){
    return (
        <div>
            <Hero/>
            <Empresa/>
            <SalesDist/>
            <Missao/>
            <PolitGest/>
            <Footer/>
            
        </div>
    );
}

export default Noticias;
